/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type UpdateVisionOptInOutAnswerMutationVariables = Types.Exact<{
  input: Types.VisionOptInUpdateInput;
}>;
export type UpdateVisionOptInOutAnswerMutation = {
  __typename?: "Mutation";
  visionOptInUpdate?: {
    __typename?: "VisionOptInUpdatePayload";
    result: {
      __typename?: "VisionOptInUpdateError";
      message: string;
    } | {
      __typename?: "VisionOptInUpdateSuccess";
      vision: {
        __typename?: "Vision";
        id: string;
        isOptedInToRecurringLooks: boolean;
      };
    };
  } | null;
};
export const UpdateVisionOptInOutAnswerDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "updateVisionOptInOutAnswer"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "input"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "VisionOptInUpdateInput"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "visionOptInUpdate"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "input"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "input"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "result"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "InlineFragment",
                typeCondition: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "VisionOptInUpdateSuccess"
                  }
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "vision"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "id"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "isOptedInToRecurringLooks"
                        }
                      }]
                    }
                  }]
                }
              }, {
                kind: "InlineFragment",
                typeCondition: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "VisionOptInUpdateError"
                  }
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "message"
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export type UpdateVisionOptInOutAnswerMutationFn = Apollo.MutationFunction<UpdateVisionOptInOutAnswerMutation, UpdateVisionOptInOutAnswerMutationVariables>;

/**
 * __useUpdateVisionOptInOutAnswerMutation__
 *
 * To run a mutation, you first call `useUpdateVisionOptInOutAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVisionOptInOutAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVisionOptInOutAnswerMutation, { data, loading, error }] = useUpdateVisionOptInOutAnswerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVisionOptInOutAnswerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVisionOptInOutAnswerMutation, UpdateVisionOptInOutAnswerMutationVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useMutation<UpdateVisionOptInOutAnswerMutation, UpdateVisionOptInOutAnswerMutationVariables>(UpdateVisionOptInOutAnswerDocument, options);
}
export type UpdateVisionOptInOutAnswerMutationHookResult = ReturnType<typeof useUpdateVisionOptInOutAnswerMutation>;
export type UpdateVisionOptInOutAnswerMutationResult = Apollo.MutationResult<UpdateVisionOptInOutAnswerMutation>;
export type UpdateVisionOptInOutAnswerMutationOptions = Apollo.BaseMutationOptions<UpdateVisionOptInOutAnswerMutation, UpdateVisionOptInOutAnswerMutationVariables>;